export const CAMPAIGN_TYPES = {
  WhatsApp: 'whatsapp_campaigns',
  Email: 'email_campaigns',
  ONGOING: 'ongoing',
  ONE_OFF: 'one_off',
  SMART_AI_EMAIL: 'smart_ai_email_campaign',
};
